import { MainApi } from "./MainApi";
import { TermsCategory } from "../types/terms";

export class TermsApi {
  static baseUrl = `${MainApi.urlPrefix}/terms`;

  static getTermsByCategory = (category: TermsCategory) => () => MainApi.api.get(`/terms?terms_category=${category}`);
}
